"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _button = _interopRequireDefault(require("../button"));

var _popoverTrigger = _interopRequireDefault(require("../popover-trigger"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tooltipCounter = 0;
/**
 * Wrap a trigger element so that when it is hovered or focused a tooltip
 * appears.
 *
 * Tooltip extends [PopoverTrigger](#popovertrigger) and configures the
 * popover and trigger for accessibility.
 */

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      visible: false,
      tooltipId: null
    });

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Save the application for the random generated id until after mount
      // so that it doesn't mess up the relation of static/dynamic React code.
      // Generating unique ids for server-rendered code without breaking
      // the checksum is very hard!
      tooltipCounter += 1;
      this.setState({
        tooltipId: "tooltip-".concat(tooltipCounter)
      });
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var content = this.props.content;

      if (typeof content === 'function') {
        return content();
      } else {
        return content;
      }
    }
  }, {
    key: "renderTrigger",
    value: function renderTrigger() {
      var _this$props = this.props,
          children = _this$props.children,
          testId = _this$props.testId;
      var tooltipId = this.state.tooltipId;

      if (!children) {
        return null;
      }

      var triggerProps = {
        'aria-describedby': tooltipId
      };

      if (testId) {
        triggerProps['data-test'] = "".concat(testId, "-trigger");
      }

      if (typeof children === 'function') {
        return children(triggerProps);
      }

      if (children.type && typeof children.type === 'string') {
        return _react.default.cloneElement(children, triggerProps);
      }

      if (children.type && children.type === _button.default) {
        return _react.default.cloneElement(children, {
          passthroughProps: triggerProps
        });
      }

      throw new Error('Tooltip requires a child that is a function, a regular DOM node, or a Button. If your trigger is a different custom component, pass a function as the child.');
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props,
          state = this.state;
      var popoverPassthroughProps = {
        id: state.tooltipId,
        // Override the "dialog" role set by popover
        role: 'tooltip'
      };

      if (props.testId) {
        popoverPassthroughProps['data-test'] = "".concat(props.testId, "-tooltip");
      }

      var bodyClasses = (0, _classnames.default)({
        'txt-s': props.textSize === 's',
        'txt-xs': props.textSize === 'xs',
        wmax120: props.maxWidth === 'small',
        wmax240: props.maxWidth === 'medium'
      });

      var content = _react.default.createElement("div", {
        className: bodyClasses
      }, this.getContent());

      return _react.default.createElement(_popoverTrigger.default, {
        content: content,
        renderHiddenContent: true,
        disabled: props.disabled,
        block: props.block,
        respondsToClick: props.respondsToClick,
        respondsToHover: true,
        respondsToFocus: true,
        receiveFocus: false,
        popoverProps: {
          hasPointer: true,
          placement: props.placement,
          alignment: props.alignment,
          coloring: props.coloring,
          padding: props.padding,
          hideWhenAnchorIsOffscreen: true,
          passthroughProps: popoverPassthroughProps
        }
      }, this.renderTrigger());
    }
  }]);

  return Tooltip;
}(_react.default.Component);

exports.default = Tooltip;
Tooltip.propTypes = {
  /**
   * The trigger element.
   *
   * If your element is a DOM element
   * (e.g. `<button>`, `<a>`, `<span>`, `<div>`),
   * you can pass it directly and it will have accessibility-related props
   * automatically added to it.
   *
   * If your element is a custom React component, you need to provide a
   * function as the child. The function will be invoked with a `triggerProps`
   * object, and you need to apply those `triggerProps` in such a way that
   * they end up on the DOM element of the trigger.
   */
  children: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]).isRequired,

  /**
   * The tooltip content. This can either be a string, valid JSX, or a function
   * returning either.
   */
  content: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]).isRequired,

  /**
   * Placement of the tooltip in relation to the trigger element.
   */
  placement: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right']),

  /**
   * Alignment of the tooltip's edge in relation to the trigger element.
   */
  alignment: _propTypes.default.oneOf(['top', 'bottom', 'left', 'right', 'center']),

  /**
   * If `true`, the tooltip will not appear.
   */
  disabled: _propTypes.default.bool,

  /**
   * `'light'`, `'dark'`, or `'warning'`.
   */
  coloring: _propTypes.default.oneOf(['light', 'dark', 'warning']),

  /**
   * `'xs'` (extra small), `'s'` (small), or `'none'` (no size class).
   */
  textSize: _propTypes.default.oneOf(['xs', 's', 'none']),

  /**
   * `'small'`, `'medium'`, or `'none'` (no `wmax*` class).
   */
  maxWidth: _propTypes.default.oneOf(['small', 'medium', 'none']),

  /**
   * `'small'` or `'none'`.
   */
  padding: _propTypes.default.oneOf(['small', 'none']),

  /**
   * If `true`, tooltip can be opened with a mouse click.
   */
  respondsToClick: _propTypes.default.bool,

  /**
   * If `true`, the element will be `block` displayed instead of `inline-block`.
   *
   * This is sometimes necessary to get your pixel-perfect layout, if you don't
   * want the extra line-height that wraps inline elements. Typically, you
   * should only set `block` to `true` if the parent element is controlling
   * width (in a layout that uses flexbox, absolute positioning, or floats).
   */
  block: _propTypes.default.bool,

  /**
   * Added as `data-test` to the tooltip element.
   */
  testId: _propTypes.default.string
};
Tooltip.defaultProps = {
  placement: 'top',
  alignment: 'center',
  coloring: 'light',
  disabled: false,
  respondsToClick: false,
  padding: 'small',
  block: false,
  textSize: 's',
  maxWidth: 'medium'
};